import { ENVIRONMENT_VARIABLES_SCHEMA } from "../environment-variables.schema";

export const PARSED_ENV = ENVIRONMENT_VARIABLES_SCHEMA.parse(import.meta.env);
export const PASSWORD_REGEX =
	/(?=[\p{L}\p{N}~`!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/]+$)^(?=.*[\p{Ll}])(?=.*[\p{Lu}])(?=.*[\p{N}])(?=.*[~`!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/])(?=.{8,}).*$/u;

/**
 * Canonical minimum password length — the single source of truth shared with the backend
 * (`passwordLength = 8`) and the `(?=.{8,})` clause in {@link PASSWORD_REGEX}. The "Set Password"
 * strength gate is the only place that enforces complexity for the invitation flow, so it must
 * use this exact minimum.
 */
export const PASSWORD_MIN_LENGTH = 8;
